"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = __importDefault(require("react-jss"));
var LogoContent_1 = __importDefault(require("./LogoContent"));
var ClickableLogo_styles_1 = __importDefault(require("./ClickableLogo.styles"));
var ClickableLogo = function (_a) {
    var classes = _a.classes, link = _a.link, rest = __rest(_a, ["classes", "link"]);
    return (react_1.default.createElement("a", { className: classes.clickable, href: link },
        react_1.default.createElement(LogoContent_1.default, __assign({}, rest))));
};
exports.default = react_jss_1.default(ClickableLogo_styles_1.default)(ClickableLogo);
//# sourceMappingURL=ClickableLogo.js.map